import { gql } from "@apollo/client";

export const JUSTIFICAR_MINUTA_MANUAL = gql`
  mutation JustificarMinutaManual ($input: JustificacionManualInput!
  ){
    justificarMinutaManual(input: $input) {
      success,
      valorEsperado,
      error
    }
}
`;